(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---- Mobile nav ---- */
  function initNav() {
    var toggle = document.querySelector("[data-nid-menu-toggle]");
    var menu = document.querySelector("[data-nid-mobile-menu]");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      var isHidden = menu.hasAttribute("hidden");
      if (isHidden) {
        menu.removeAttribute("hidden");
      } else {
        menu.setAttribute("hidden", "");
      }
    });
  }

  /* ---- Nav dropdown (desktop) ---- */
  function initNavDropdowns() {
    var dropdowns = document.querySelectorAll("[data-nid-dropdown]");
    if (!dropdowns.length) return;

    function closeAll(except) {
      dropdowns.forEach(function (dropdown) {
        if (dropdown === except) return;
        dropdown.classList.remove("is-open");
        var trigger = dropdown.querySelector("[data-nid-dropdown-trigger]");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      });
    }

    dropdowns.forEach(function (dropdown) {
      var trigger = dropdown.querySelector("[data-nid-dropdown-trigger]");
      if (!trigger) return;
      trigger.addEventListener("click", function (event) {
        event.stopPropagation();
        var isOpen = dropdown.classList.contains("is-open");
        closeAll(dropdown);
        dropdown.classList.toggle("is-open", !isOpen);
        trigger.setAttribute("aria-expanded", String(!isOpen));
      });
    });

    document.addEventListener("click", function () {
      closeAll();
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeAll();
    });
  }

  /* ---- Policy page headings (splits "ALL CAPS LABEL Body sentence..." into a styled heading) ---- */
  function initPolicyHeadings() {
    document.querySelectorAll(".nid-policy-page #MainContent p").forEach(function (p) {
      var words = p.textContent.split(" ");
      var i = 0;
      while (i < words.length) {
        var letters = words[i].replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, "");
        if (letters.length === 0) {
          i++;
          continue;
        }
        if (letters === letters.toUpperCase() && letters !== letters.toLowerCase()) {
          i++;
        } else {
          break;
        }
      }
      if (i >= 2 && i < words.length) {
        var heading = document.createElement("h2");
        heading.className = "nid-policy-heading";
        heading.textContent = words.slice(0, i).join(" ");
        var body = document.createElement("p");
        body.textContent = words.slice(i).join(" ");
        p.replaceWith(heading, body);
      }
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll("[data-nid-faq-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var item = trigger.closest(".nid-faq-item");
        var panel = item.querySelector("[data-nid-faq-panel]");
        var isOpen = item.classList.contains("is-open");
        item.classList.toggle("is-open", !isOpen);
        panel.classList.toggle("is-open", !isOpen);
        trigger.setAttribute("aria-expanded", String(!isOpen));
      });
    });
  }

  /* ---- Product details accordion (starts closed) ---- */
  function initDetailsAccordion() {
    document.querySelectorAll("[data-nid-details-accordion]").forEach(function (root) {
      var toggle = root.querySelector("[data-nid-details-toggle]");
      var content = root.querySelector("[data-nid-details-content]");
      if (!toggle || !content) return;

      root.classList.add("is-closed");
      toggle.setAttribute("aria-expanded", "false");
      content.style.maxHeight = "0px";

      toggle.addEventListener("click", function () {
        var isOpen = !root.classList.contains("is-closed");
        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          requestAnimationFrame(function () {
            content.style.maxHeight = "0px";
          });
          root.classList.add("is-closed");
          toggle.setAttribute("aria-expanded", "false");
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          root.classList.remove("is-closed");
          toggle.setAttribute("aria-expanded", "true");
          content.addEventListener("transitionend", function handler() {
            content.style.maxHeight = "none";
            content.removeEventListener("transitionend", handler);
          });
        }
      });
    });
  }

  /* ---- Reviews grid "show more" ---- */
  function initReviewsGrid() {
    document.querySelectorAll("[data-nid-reviews-grid]").forEach(function (grid) {
      var button = grid.parentElement.querySelector("[data-nid-reviews-show-more]");
      if (!button) return;
      button.addEventListener("click", function () {
        grid.querySelectorAll("[data-nid-review-item]").forEach(function (item) {
          item.removeAttribute("hidden");
        });
        button.style.display = "none";
      });
    });
  }

  /* ---- Review carousels (3-per-page rotation) ---- */
  function initCarousels() {
    document.querySelectorAll("[data-nid-carousel]").forEach(function (root) {
      var track = root.querySelector("[data-nid-carousel-track]");
      var pages = track ? track.children.length : 0;
      if (!track || pages <= 1) return;
      var page = 0;

      function render() {
        track.style.transform = "translateX(-" + page * 100 + "%)";
        root.querySelectorAll("[data-nid-carousel-dot]").forEach(function (dot, i) {
          dot.style.backgroundColor = i === page ? "#5F5D8C" : "#E5E5E5";
        });
      }

      var prev = root.querySelector("[data-nid-carousel-prev]");
      var next = root.querySelector("[data-nid-carousel-next]");
      if (prev) prev.addEventListener("click", function () { page = (page - 1 + pages) % pages; render(); });
      if (next) next.addEventListener("click", function () { page = (page + 1) % pages; render(); });

      root.querySelectorAll("[data-nid-carousel-dot]").forEach(function (dot) {
        dot.addEventListener("click", function () {
          page = parseInt(dot.getAttribute("data-index"), 10) || 0;
          render();
        });
      });
    });
  }

  /* ---- Timeline step videos: play while in view ---- */
  function initStepVideos() {
    var videos = document.querySelectorAll("[data-nid-step-video]");
    if (!videos.length || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    videos.forEach(function (video) { observer.observe(video); });
  }

  /* ---- Sticky mobile CTA bar: shows when the buy box is off-screen ---- */
  function initStickyCta() {
    var bar = document.querySelector("[data-nid-sticky-cta]");
    var buyBox = document.getElementById("buy-box");
    if (!bar || !buyBox || !("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle("is-visible", !entry.isIntersecting);
          bar.setAttribute("aria-hidden", entry.isIntersecting ? "true" : "false");
        });
      },
      { threshold: 0 }
    );
    observer.observe(buyBox);
  }

  /* ---- Shipping date (always shows tomorrow) ---- */
  function updateShippingDates() {
    var els = document.querySelectorAll("[data-nid-shipping-date]");
    if (!els.length) return;
    var d = new Date();
    d.setDate(d.getDate() + 1);
    var parts = d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" }).split(" ");
    parts[0] = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
    parts[2] = parts[2].charAt(0).toUpperCase() + parts[2].slice(1);
    var text = "Expédition : " + parts.join(" ");
    els.forEach(function (el) { el.textContent = text; });
  }

  /* ---- Cart drawer ---- */
  function formatMoneyGlobal(cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
  }

  /* Cadeaux offerts avec la fontaine : s'ils restent seuls dans le panier (fontaine retirée), on les retire aussi. */
  var GIFT_PARENT_HANDLE = "fontaine-meowlia";
  var pruning = false;
  function orphanGiftUpdates(cart) {
    if (!cart || !cart.items) return null;
    var hasParent = cart.items.some(function (i) { return i.handle === GIFT_PARENT_HANDLE; });
    if (hasParent) return null;
    var updates = {}, n = 0;
    cart.items.forEach(function (i) { if (i.handle && i.handle.indexOf("cadeau-") === 0) { updates[i.key] = 0; n++; } });
    return n ? updates : null;
  }
  function pruneOrphanGifts(cart) {
    var updates = orphanGiftUpdates(cart);
    if (!updates || pruning) return false;
    pruning = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (res) { return res.json(); })
      .then(function (newCart) {
        pruning = false;
        if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        CartDrawer.render(newCart);
      })
      .catch(function () { pruning = false; });
    return true;
  }

  var CartDrawer = (function () {
    var root, panel, itemsEl, emptyEl, footerEl, countEl, subtotalEl;

    function els() {
      root = root || document.querySelector("[data-nid-cart-drawer]");
      if (!root) return false;
      itemsEl = itemsEl || root.querySelector("[data-nid-cart-drawer-items]");
      emptyEl = emptyEl || root.querySelector("[data-nid-cart-drawer-empty]");
      footerEl = footerEl || root.querySelector("[data-nid-cart-drawer-footer]");
      countEl = countEl || root.querySelector("[data-nid-cart-drawer-count]");
      subtotalEl = subtotalEl || root.querySelector("[data-nid-cart-drawer-subtotal]");
      return true;
    }

    function open() {
      if (!els()) return;
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }

    function close() {
      if (!els()) return;
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }

    function propsHtml(props) {
      if (!props) return "";
      var out = "";
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if (!v || k.charAt(0) === "_") return;
        var esc = function (x) { return String(x).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
        out += '<p class="nid-cart-drawer-line-variant">' + esc(k) + " : " + esc(v) + "</p>";
      });
      return out;
    }

    function lineHtml(line) {
      var variantText = line.variant_title && line.variant_title !== "Default Title" ? line.variant_title : "";
      var image = line.image ? line.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_160x160$1$2") : "";
      var refUnit = line.compare_at_price && line.compare_at_price > line.price ? line.compare_at_price : line.price;
      var compareLinePrice = refUnit * line.quantity;
      var lineSavings = compareLinePrice > line.final_line_price ? compareLinePrice - line.final_line_price : 0;
      var isGift = line.final_line_price === 0 && line.original_line_price > 0;

      return (
        '<div class="nid-cart-drawer-line" data-nid-cart-line data-key="' + line.key + '">' +
          (image ? '<img class="nid-cart-drawer-line-image" src="' + image + '" alt="" width="72" height="72" loading="lazy">' : '<div class="nid-cart-drawer-line-image"></div>') +
          '<div style="flex: 1; min-width: 0;">' +
            '<p class="nid-cart-drawer-line-title">' + line.product_title + "</p>" +
            (variantText ? '<p class="nid-cart-drawer-line-variant">' + variantText + "</p>" : "") +
            propsHtml(line.properties) +
            '<div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap;">' +
              '<div class="nid-cart-drawer-qty">' +
                '<button type="button" data-nid-cart-qty-minus aria-label="Diminuer la quantité">' + "−" + "</button>" +
                '<span>' + line.quantity + "</span>" +
                '<button type="button" data-nid-cart-qty-plus aria-label="Augmenter la quantité">+</button>' +
              "</div>" +
              '<div style="display: flex; align-items: center; gap: 6px;">' +
                (lineSavings > 0 ? '<span class="nid-cart-drawer-line-compare">' + formatMoneyGlobal(compareLinePrice) + "</span>" : "") +
                (isGift ? '<span class="nid-cart-drawer-line-price" style="color:#3e7c47;font-weight:800">Offert</span>' : '<span class="nid-cart-drawer-line-price">' + formatMoneyGlobal(line.final_line_price) + "</span>") +
              "</div>" +
            "</div>" +
            (lineSavings > 0 && !isGift ? '<span class="nid-cart-drawer-savings-tag">Vous économisez ' + formatMoneyGlobal(lineSavings) + "</span>" : "") +
            '<button type="button" class="nid-cart-drawer-line-remove" data-nid-cart-line-remove>Retirer</button>' +
          "</div>" +
        "</div>"
      );
    }

    function render(cart) {
      if (pruneOrphanGifts(cart)) return;
      if (!els()) return;

      if (countEl) countEl.textContent = "(" + cart.item_count + ")";
      document.querySelectorAll("[data-nid-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "flex" : "none";
      });

      if (!cart.items.length) {
        if (itemsEl) itemsEl.innerHTML = "";
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.style.display = "none";
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.style.display = "";
      if (itemsEl) itemsEl.innerHTML = cart.items.map(lineHtml).join("");
      if (subtotalEl) subtotalEl.textContent = formatMoneyGlobal(cart.total_price);

      var checkoutPriceEl = footerEl.querySelector("[data-nid-cart-drawer-checkout-price]");
      if (checkoutPriceEl) checkoutPriceEl.textContent = formatMoneyGlobal(cart.total_price);

      var totalSavings = cart.items.reduce(function (sum, item) {
        var ref = (item.compare_at_price && item.compare_at_price > item.price ? item.compare_at_price : item.price) * item.quantity;
        return sum + (ref > item.final_line_price ? ref - item.final_line_price : 0);
      }, 0);
      var savingsRow = footerEl.querySelector("[data-nid-cart-drawer-savings-row]");
      var savingsEl = footerEl.querySelector("[data-nid-cart-drawer-savings]");
      if (savingsRow && savingsEl) {
        if (totalSavings > 0) {
          savingsEl.textContent = "Vous économisez " + formatMoneyGlobal(totalSavings);
          savingsRow.style.display = "flex";
        } else {
          savingsRow.style.display = "none";
        }
      }
    }

    function fetchCart() {
      return fetch("/cart.js").then(function (res) { return res.json(); });
    }

    function refresh() {
      return fetchCart().then(function (cart) {
        render(cart);
        return cart;
      });
    }

    function changeLine(key, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          render(cart);
          return cart;
        });
    }

    function openWithCart(cart) {
      render(cart);
      open();
    }

    function bindStaticEvents() {
      if (!els()) return;

      root.addEventListener("click", function (evt) {
        if (evt.target.closest("[data-nid-cart-drawer-close]")) {
          evt.preventDefault();
          close();
        }
      });

      itemsEl.addEventListener("click", function (evt) {
        var line = evt.target.closest("[data-nid-cart-line]");
        if (!line) return;
        var key = line.getAttribute("data-key");
        var qtySpan = line.querySelector(".nid-cart-drawer-qty span");
        var currentQty = parseInt(qtySpan.textContent, 10) || 1;

        if (evt.target.closest("[data-nid-cart-qty-plus]")) {
          changeLine(key, currentQty + 1);
        } else if (evt.target.closest("[data-nid-cart-qty-minus]")) {
          changeLine(key, Math.max(0, currentQty - 1));
        } else if (evt.target.closest("[data-nid-cart-line-remove]")) {
          changeLine(key, 0);
        }
      });

      document.querySelectorAll("[data-nid-cart-drawer-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function (evt) {
          evt.preventDefault();
          refresh();
          open();
        });
      });

      document.addEventListener("keydown", function (evt) {
        if (evt.key === "Escape") close();
      });
    }

    return { open: openWithCart, close: close, refresh: refresh, render: render, bindStaticEvents: bindStaticEvents };
  })();

  /* ---- Product gallery + variant form + AJAX add to cart ---- */
  function initProductSections() {
    document.querySelectorAll("[data-nid-product-section]").forEach(initOneProductSection);
  }

  function initOneProductSection(section) {
    var mainImage = section.querySelector("[data-nid-gallery-image]");
    var thumbTrack = section.querySelector("[data-nid-thumb-track]");
    var thumbViewport = section.querySelector("[data-nid-thumb-viewport]");
    var thumbButtons = Array.prototype.slice.call(section.querySelectorAll("[data-nid-thumb]"));
    var itemSize = 80;
    var gap = 8;
    var offset = 0;

    function visibleCount() {
      if (!thumbViewport) return 4;
      var width = thumbViewport.clientWidth || (4 * itemSize + 3 * gap);
      return Math.max(1, Math.floor((width + gap) / (itemSize + gap)));
    }

    var activeIndex = 0;

    function setActiveThumb(index) {
      activeIndex = index;
      thumbButtons.forEach(function (btn, i) {
        btn.style.borderColor = i === index ? "#5F5D8C" : "transparent";
        btn.style.transform = i === index ? "scale(0.96)" : "scale(1)";
      });
    }

    function setMainImage(full) {
      if (!mainImage || !full) return;
      mainImage.style.opacity = "0";
      window.setTimeout(function () {
        mainImage.setAttribute("src", full);
        mainImage.style.opacity = "1";
      }, 150);
    }

    function goToIndex(index) {
      var count = thumbButtons.length;
      if (count === 0) return;
      index = ((index % count) + count) % count;
      var btn = thumbButtons[index];
      if (!btn) return;
      setMainImage(btn.getAttribute("data-full"));
      setActiveThumb(index);
      ensureVisible(index);
    }

    thumbButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        goToIndex(parseInt(btn.getAttribute("data-index"), 10));
      });
    });

    var mainPrevBtn = section.querySelector("[data-nid-main-prev]");
    var mainNextBtn = section.querySelector("[data-nid-main-next]");
    if (mainPrevBtn) {
      mainPrevBtn.addEventListener("click", function () {
        goToIndex(activeIndex - 1);
      });
    }
    if (mainNextBtn) {
      mainNextBtn.addEventListener("click", function () {
        goToIndex(activeIndex + 1);
      });
    }

    if (mainImage) mainImage.style.transition = "opacity 0.15s ease";

    var prevBtn = section.querySelector("[data-nid-thumb-prev]");
    var nextBtn = section.querySelector("[data-nid-thumb-next]");

    function maxOffset() {
      return Math.max(0, thumbButtons.length - visibleCount());
    }

    function updateThumbTrack() {
      if (!thumbTrack) return;
      var x = -offset * (itemSize + gap);
      thumbTrack.style.transform = "translateX(" + x + "px)";
      var needsScroll = thumbButtons.length > visibleCount();
      var atStart = offset <= 0;
      var atEnd = offset >= maxOffset();
      if (prevBtn) prevBtn.style.display = needsScroll ? "flex" : "none";
      if (nextBtn) nextBtn.style.display = needsScroll ? "flex" : "none";
      if (prevBtn) {
        prevBtn.disabled = atStart;
        prevBtn.style.opacity = atStart ? "0.35" : "1";
        prevBtn.style.cursor = atStart ? "default" : "pointer";
      }
      if (nextBtn) {
        nextBtn.disabled = atEnd;
        nextBtn.style.opacity = atEnd ? "0.35" : "1";
        nextBtn.style.cursor = atEnd ? "default" : "pointer";
      }
    }

    function ensureVisible(index) {
      var vc = visibleCount();
      if (index < offset) {
        offset = index;
      } else if (index >= offset + vc) {
        offset = index - vc + 1;
      }
      offset = Math.max(0, Math.min(maxOffset(), offset));
      updateThumbTrack();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        offset = Math.max(0, offset - 1);
        updateThumbTrack();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        offset = Math.min(maxOffset(), offset + 1);
        updateThumbTrack();
      });
    }
    if (thumbButtons.length > 0) {
      updateThumbTrack();
      window.addEventListener("resize", function () {
        offset = Math.max(0, Math.min(maxOffset(), offset));
        updateThumbTrack();
      });
    }

    /* Swipe support on main image (touch) */
    if (mainImage) {
      var touchStartX = null;
      mainImage.addEventListener(
        "touchstart",
        function (evt) {
          touchStartX = evt.touches[0].clientX;
        },
        { passive: true }
      );
      mainImage.addEventListener(
        "touchend",
        function (evt) {
          if (touchStartX === null) return;
          var deltaX = evt.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(deltaX) < 40) return;
          goToIndex(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
        },
        { passive: true }
      );
    }

    /* Variant selection */
    var variantsScript = section.querySelector("[data-nid-variants-json]");
    var variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var form = section.querySelector("[data-nid-product-form]");
    if (!form) return;
    var variantIdInput = form.querySelector("[data-nid-variant-id]");
    var priceEl = form.querySelector("[data-nid-price]");
    var comparePriceEl = form.querySelector("[data-nid-compare-price]");
    var discountBadge = form.querySelector("[data-nid-discount-badge]");
    var discountPercentEl = form.querySelector("[data-nid-discount-percent]");
    var atcButton = form.querySelector("[data-nid-add-to-cart]");
    var atcLabel = form.querySelector("[data-nid-atc-label]");
    var atcPrice = form.querySelector("[data-nid-atc-price]");
    var atcCompare = form.querySelector("[data-nid-atc-compare]");
    var cartMessage = form.querySelector("[data-nid-cart-message]");

    function formatMoney(cents) {
      return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    }

    function currentSelection() {
      var groups = form.querySelectorAll("[data-nid-option-group]");
      var options = [];
      groups.forEach(function (group) {
        var position = parseInt(group.getAttribute("data-option-position"), 10);
        var type = group.getAttribute("data-option-type");
        var value = null;
        if (type === "card") {
          var checked = group.querySelector("[data-nid-option-input]:checked");
          if (checked) value = checked.value;
        } else {
          var pressed = group.querySelector('[data-nid-option-pill][aria-pressed="true"]');
          if (pressed) value = pressed.getAttribute("data-value");
        }
        options[position - 1] = value;
      });
      return options;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return (
          (options[0] == null || v.option1 === options[0]) &&
          (options[1] == null || v.option2 === options[1]) &&
          (options[2] == null || v.option3 === options[2])
        );
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (atcPrice) atcPrice.textContent = formatMoney(variant.price);

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (comparePriceEl) {
        comparePriceEl.style.display = hasCompare ? "" : "none";
        if (hasCompare) comparePriceEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (atcCompare) {
        atcCompare.style.display = hasCompare ? "" : "none";
        if (hasCompare) atcCompare.textContent = formatMoney(variant.compare_at_price);
      }
      if (discountBadge) discountBadge.style.display = hasCompare ? "" : "none";
      if (hasCompare && discountPercentEl) {
        discountPercentEl.textContent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      }

      if (atcButton) atcButton.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? atcLabel.getAttribute("data-in-stock-text") || atcLabel.textContent : "Rupture de stock";

      if (variant.featured_image && variant.featured_image.src && mainImage) {
        mainImage.setAttribute("src", variant.featured_image.src);
      }
    }

    form.querySelectorAll("[data-nid-option-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        var group = input.closest("[data-nid-option-group]");
        group.querySelectorAll("[data-nid-option-card]").forEach(function (label) {
          var r = label.querySelector("[data-nid-option-input]");
          label.style.borderColor = r && r.checked ? "#5F5D8C" : "#E5E5E5";
        });
        var variant = findVariant(currentSelection());
        if (variant) updateForVariant(variant);
      });
    });

    function updateSizeCardImages() {
      var baseOptions = currentSelection();
      form.querySelectorAll('[data-nid-option-group][data-option-type="card"]').forEach(function (group) {
        var position = parseInt(group.getAttribute("data-option-position"), 10);
        group.querySelectorAll("[data-nid-option-card]").forEach(function (card) {
          var sizeValue = card.getAttribute("data-size-value");
          var opts = baseOptions.slice();
          opts[position - 1] = sizeValue;
          var variant = findVariant(opts);
          var img = card.querySelector("[data-nid-size-card-image]");
          if (variant && variant.featured_image && variant.featured_image.src && img) {
            img.setAttribute("src", variant.featured_image.src);
          }
        });
      });
    }

    form.querySelectorAll("[data-nid-option-pill]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var group = pill.closest("[data-nid-option-group]");
        group.querySelectorAll("[data-nid-option-pill]").forEach(function (p) {
          p.setAttribute("aria-pressed", "false");
          p.style.borderColor = "#E5E5E5";
        });
        pill.setAttribute("aria-pressed", "true");
        pill.style.borderColor = "#5F5D8C";
        updateSizeCardImages();
        var variant = findVariant(currentSelection());
        if (variant) updateForVariant(variant);
      });
    });

    /* Submit via AJAX */
    form.addEventListener("submit", function (evt) {
      evt.preventDefault();
      if (atcButton) atcButton.disabled = true;

      var formData = new FormData(form);
      var items = [
        {
          id: parseInt(formData.get("id"), 10),
          quantity: parseInt(formData.get("quantity"), 10) || 1,
          properties: {},
        },
      ];
      formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match) items[0].properties[match[1]] = value;
      });

      section.querySelectorAll("[data-nid-upsell-checkbox]").forEach(function (checkbox) {
        var variantId = checkbox.getAttribute("data-variant-id");
        if (checkbox.checked && variantId) {
          items.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
      });

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch("/cart.js").then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          CartDrawer.open(cart);
        })
        .catch(function () {
          if (cartMessage) {
            cartMessage.style.color = "#c0392b";
            cartMessage.textContent = "Une erreur est survenue. Merci de réessayer.";
            cartMessage.style.display = "block";
          }
        })
        .finally(function () {
          if (atcButton) atcButton.disabled = false;
        });
    });
  }

  ready(function () {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(pruneOrphanGifts).catch(function () {});
    CartDrawer.bindStaticEvents();
    initNav();
    initNavDropdowns();
    initPolicyHeadings();
    initFaq();
    initDetailsAccordion();
    initReviewsGrid();
    initCarousels();
    initStepVideos();
    initProductSections();
    updateShippingDates();
    initStickyCta();
  });
})();
